import process from "shelljs";

export const API_URL = localStorage.getItem('BFF_URL') || process.env.BFF_URL;



// WEBPACK FOOTER //
// ./src/utils/config.util.js